import { render, staticRenderFns } from "./CompaniesManagement.vue?vue&type=template&id=f8a988ec&scoped=true&"
import script from "./companies-management.ts?vue&type=script&lang=ts&"
export * from "./companies-management.ts?vue&type=script&lang=ts&"
import style0 from "./CompaniesManagement.vue?vue&type=style&index=0&id=f8a988ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a988ec",
  null
  
)

export default component.exports